export const env = {
    // Gets set to true before storybook stories are run
    isStorybookStory: false,
    // String should be replaced with a version number when building with rollup
    rtdVersion: '__RTD_VERSION',
};
